import React, { Component } from "react";
import "./AddMessage.css";

export default class AddMessage extends Component {
  constructor(props) {
    super(props);
    this.state = { input: "" };
    let searchParams = new URLSearchParams(window.location.search.slice(1));
  }

  handleChange(e) {
    this.setState({ input: e.target.value });
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      document.querySelector("#add-message-btn").click();
    }
  }

  handleSend(e) {
    let input = this.state.input;
    if (input !== "") {
      this.props.handleSend(input);
    }
    this.setState({ input: "" });
    document.querySelector("#add-message-input").value = "";
  }

  render() {
    if (this.props.readonly) {
      return null;
      // return (
      //   <div id="add-message" class="closed">
      //     <div class="msg">Este chat está encerrado.</div>
      //   </div>
      // );
    } else {
      return (
        <div id="add-message">
          <input
            type="text"
            id="add-message-input"
            autoFocus
            onChange={(e) => this.handleChange(e)}
            onKeyDown={(e) => this.handleKeyDown(e)}
          />
          <button id="add-message-btn" onClick={(e) => this.handleSend(e)}>
            <i className="icon-send" />
          </button>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/chat/AddMessage.js